import React from "react";
import { Image, Row, Col, Container, Form, Button, InputGroup, FormControl } from "react-bootstrap";
import "./Donate.css";
import { Link, Redirect } from "react-router-dom";
import Helper from "../Helper/helper";
import api from "../../Environment";
import { withToastManager } from "react-toast-notifications";
import ToastDemo from "../Helper/toaster";

import { translate, t } from "react-multi-lang";
import configuration from "react-global-configuration";
import PaypalExpressBtn from "react-paypal-express-checkout";
import { getDonationPageConfig, isExternalHref } from "../Helper/siteContent";
import BrandLinksRow from "../Helper/BrandLinksRow";
import { normalizeExternalUrl } from "../Helper/urls";
import { fetchDonationTarget } from "../Donations/donationEngineApi";
import { fetchOrganizationBySlug } from "../Helper/organizations";
import {
  entityPublicPath,
  entityDonateThankYouPath,
  entityFromDonatePath,
} from "../Helper/entityRoutes";
import { resolveMediaUrl, handleMediaImgError } from "../Helper/mediaUrl";
import { AppearanceButton } from "../Appearance";
import EntityIdentity from "../Helper/EntityIdentity";
import { buildEntityBadges } from "../Helper/EntityBadges";
import { isPaypalCheckoutVisible } from "../User/Settings/checkoutPaymentHelpers";

function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement('script')
      script.src = src
      script.onload = () => {
        resolve(true)
      }
      script.onerror = () => {
        resolve(false)
      }
      document.body.appendChild(script)
    })
}

class DonateFeature extends Helper {

    state = {
        inputData: {
            amount: 10,
            payment_mode: 'card',
        },
        loadingContent: null,
        buttonDisable: false,
        paymentMode: 'card',
        donationPage: getDonationPageConfig(),
        projectSlug: "",
        branded: false,
        entityType: "",
        entityId: "",
        entityName: "",
        entitySlug: "",
        entityLogo: "",
        entityCover: "",
        entityBadges: [],
        entityTypeLabel: "",
        entityBackPath: "/community",
        donationComplete: false,
        completedAmount: null,
        entityLoading: false,
        thankYouRedirect: null,
    };

    componentDidMount() {
        const donationPage = getDonationPageConfig();
        const firstAmount =
            donationPage.amounts && donationPage.amounts.length
                ? donationPage.amounts[0]
                : 10;
        let projectSlug = "";
        let entityType = "";
        let entityId = "";
        let entityName = "";
        let entitySlug = "";
        let branded = false;

        const fromPath = entityFromDonatePath(
            this.props.location && this.props.location.pathname
        );
        if (fromPath) {
            entityType = fromPath.entityType;
            entitySlug = fromPath.slug;
            branded = true;
        }

        try {
            const params = new URLSearchParams(window.location.search || "");
            projectSlug = (params.get("project") || "").trim();
            if (!entityType) {
                entityType = (params.get("entity_type") || "").trim().toLowerCase();
            }
            entityId = (params.get("entity_id") || "").trim();
            entityName = (params.get("entity_name") || "").trim();
            if (!entitySlug) {
                entitySlug = (params.get("entity_slug") || "").trim();
            }
            if (!branded) {
                branded = params.get("branded") === "1" || !!entityType;
            }
            if (params.get("donation") === "success" || params.get("thanks") === "1") {
                this.setState({ donationComplete: true });
            }
        } catch (e) {
            projectSlug = "";
        }
        const inputData = {
            ...this.state.inputData,
            amount: firstAmount,
        };
        if (projectSlug) {
            inputData.project_slug = projectSlug;
        }
        if (entityType) {
            inputData.entity_type = entityType;
        }
        if (entityId) {
            inputData.entity_id = entityId;
        }
        if (entityName) {
            inputData.entity_name = entityName;
        }
        const entityBackPath = this.resolveBackPath(entityType, entitySlug || projectSlug);
        this.setState({
            donationPage,
            projectSlug,
            inputData,
            branded,
            entityType,
            entityId,
            entityName,
            entitySlug: entitySlug || projectSlug,
            entityBackPath,
        });
        if (branded && (entityType || entitySlug || entityId)) {
            this.loadEntityBranding(entityType, entitySlug || entityId, entityName);
        }
    }

    resolveBackPath(entityType, slug) {
        if (!slug) return "/community";
        return entityPublicPath(entityType, slug);
    }

    goToThankYou = (amount) => {
        const type =
            this.state.entityType === "org"
                ? "organization"
                : this.state.entityType || "organization";
        const slug = this.state.entitySlug;
        try {
            if (amount != null) {
                sessionStorage.setItem(
                    "donate_thank_you_amount",
                    String(amount)
                );
            }
        } catch (e) {
            /* ignore */
        }
        if (slug && this.props.history) {
            this.props.history.push(entityDonateThankYouPath(type, slug));
            return;
        }
        this.setState({
            donationComplete: true,
            completedAmount: amount,
            thankYouRedirect: slug
                ? entityDonateThankYouPath(type, slug)
                : null,
        });
    };

    loadEntityBranding = async (entityType, idOrSlug, fallbackName) => {
        this.setState({ entityLoading: true });
        const type =
            entityType === "org" ? "organization" : entityType || "organization";
        const target = await fetchDonationTarget(type, idOrSlug);
        let badges = [];
        let name = fallbackName || "";
        let logo = "";
        let cover = "";
        let handle = idOrSlug || "";
        let typeLabel = "";
        let entityId = this.state.entityId || "";
        if (target && target.found !== false) {
            const branding = target.branding || {};
            name = branding.title || target.title || name;
            logo = branding.logo || target.logo || "";
            cover = branding.cover || target.image || "";
            handle = target.slug || handle;
            if (target.target_id) {
                entityId = String(target.target_id);
            }
        }
        if (type === "organization" && handle) {
            const org = await fetchOrganizationBySlug(handle);
            if (org) {
                badges = buildEntityBadges(org);
                if (!logo && org.logo_path) logo = org.logo_path;
                if (!cover && org.cover_image_path) cover = org.cover_image_path;
                if (!name && org.name) name = org.name;
                if (!entityId && org.id) entityId = String(org.id);
                typeLabel =
                    org.organization_type_label ||
                    org.type_label ||
                    org.organization_type ||
                    "Organization";
            }
        }
        if (!typeLabel) {
            typeLabel =
                type === "creator"
                    ? "Creator"
                    : type === "project"
                    ? "Project"
                    : "Organization";
        }
        const inputData = {
            ...this.state.inputData,
            entity_type: type,
            entity_name: name || this.state.entityName,
        };
        if (entityId) {
            inputData.entity_id = entityId;
        }
        this.setState({
            entityLoading: false,
            entityName: name || this.state.entityName,
            entityLogo: logo,
            entityCover: cover,
            entitySlug: handle || this.state.entitySlug,
            entityBadges: badges,
            entityTypeLabel: typeLabel,
            entityId: entityId || this.state.entityId,
            entityBackPath: this.resolveBackPath(type, handle || this.state.entitySlug),
            entityType: type,
            inputData,
        });
    };
      
    handleChange = ({ currentTarget: input }) => {
        const inputData = { ...this.state.inputData };
        inputData[input.name] = input.value;
        this.setState({ inputData });
    };

    handleChangePayment = ({ currentTarget: input }) => {
        const inputData = { ...this.state.inputData };
        inputData['payment_mode'] = input.value;
        this.setState({ paymentMode: input.value,inputData });
    };

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({
            loadingContent: this.props.t("loading_text"),
            buttonDisable: true,
        });

        if(this.state.paymentMode == "razorpay") {
            this.displayRazorpay();
        } else if (this.state.paymentMode == "paystack") {
            this.paymentPayStackApiCall();
        }else {
            this.paymentApiCall();
        }

    };

    paymentPayStackApiCall = () => {
        api.postMethod("user_donations_via_paystack", this.state.inputData)
        .then((response) => {
            if (response.data.success) {
                ToastDemo(this.props.toastManager, response.data.message, "success");
                this.setState({
                    loadingContentCard: null,
                    buttonDisable: false,
                });
                if (response.data.data.authorization_url) {
                    window.location.href = response.data.data.authorization_url;
                } else if (this.state.branded) {
                    this.goToThankYou(this.state.inputData.amount);
                } else {
                    window.location.reload();
                }
            } else {
                ToastDemo(
                    this.props.toastManager,
                    response.data.error,
                    "error"
                );
                this.setState({
                    loadingContentCard: null,
                    buttonDisable: false,
                });
            }
        })
        .catch((error) => {
            ToastDemo(this.props.toastManager, error, "error");
            this.setState({
            loadingContentCard: null,
            buttonDisable: false,
            });
        });
    };


    displayRazorpay = async () => {

        const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js')
    
        if (!res) {
            alert('Razorpay SDK failed to load. Are you online?')
            return
        }
    
        const data = await api.postMethod("user_donations_via_razorpay_create_order", this.state.inputData).then(res => res.data);

        // console.log(data);
        if (data.success) {
            const options = {
                key: configuration.get("configData.RAZOR_KEY"),
                currency: data.data.currency,
                amount: data.data.amount.toString(),
                order_id: data.data.id,
                name: this.state.branded && this.state.entityName
                    ? this.state.entityName
                    : 'Donation',
                description: this.state.branded && this.state.entityName
                    ? ('Donation to ' + this.state.entityName)
                    : 'Donation',
                handler: async (response) => {
                    try {
                        const inputData = { ...this.state.inputData };
                        inputData['payment_id'] = response.razorpay_payment_id;
                        this.setState({inputData});

                        this.paymentApiCall();
                      
                    } catch (err) {
                        ToastDemo(
                            this.props.toastManager,
                            err && err.message ? err.message : "Payment error",
                            "error"
                        );
                        this.setState({
                            loadingContentCard: null,
                            buttonDisable: false,
                        });
                    }
                }
            }
            const paymentObject = new window.Razorpay(options)
            paymentObject.open()
        } else {
            ToastDemo(
                this.props.toastManager,
                data.error_messages,
                "error"
            );
            this.setState({
                loadingContentCard: null,
                buttonDisable: false,
            });
        }
        
    }
    paymentApiCall = () => { 

        api
        .postMethod("user_donations_via_card", this.state.inputData)
        .then((response) => {
            if (response.data.success) {
                ToastDemo(this.props.toastManager, response.data.message, "success");
                
                this.setState({
                    loadingContent: null,
                    buttonDisable: false,
                });
                if (this.state.branded) {
                    this.goToThankYou(this.state.inputData.amount);
                } else {
                    setTimeout(function() {
                        window.location.reload();
                    }, 1000);
                }

            } else {
                ToastDemo(
                    this.props.toastManager,
                    response.data.error_messages,
                    "error"
                );
                this.setState({
                    loadingContent: null,
                    buttonDisable: false,
                });
            }
        })
        .catch((error) => {
            this.setState({ loadingContent: null, buttonDisable: false });
            ToastDemo(this.props.toastManager, error, "error");
        });

    }

    /**
     * Shared Entity Identity (same as Organization page) + optional logo /
     * support copy for donation composition. No donate-specific identity typography.
     */
    renderSharedEntityIdentity({
        supportLine = false,
        poweredBy = false,
        entityName,
        entityNoun,
    }) {
        const name = entityName || this.state.entityName || "Community partner";
        const entityType = this.state.entityType || "organization";
        const logoSrc = this.state.entityLogo
            ? resolveMediaUrl(this.state.entityLogo)
            : "";
        const typeLabel =
            this.state.entityTypeLabel ||
            (entityType === "creator"
                ? "Creator"
                : entityType === "project"
                ? "Project"
                : "Organization");

        return (
            <div className="donate-checkout-identity">
                {logoSrc ? (
                    <img
                        src={logoSrc}
                        alt={name}
                        className="org-logo"
                        onError={handleMediaImgError}
                    />
                ) : (
                    <div
                        className="org-logo-placeholder"
                        role="img"
                        aria-label={name}
                    >
                        <i
                            className={
                                entityType === "creator"
                                    ? "fas fa-user"
                                    : entityType === "project"
                                    ? "fas fa-folder-open"
                                    : "fas fa-building"
                            }
                            aria-hidden="true"
                        />
                    </div>
                )}
                <EntityIdentity
                    name={name}
                    handle={this.state.entitySlug}
                    typeLabel={typeLabel}
                    badges={this.state.entityBadges}
                    variant="checkout"
                />
                {supportLine !== false ? (
                    <p className="donate-checkout-identity__support">
                        {typeof supportLine === "string"
                            ? supportLine
                            : `Supporting this ${entityNoun || "Organization"}`}
                    </p>
                ) : null}
                {poweredBy ? (
                    <p className="donate-checkout-identity__powered">
                        Securely processed by Pentecost+
                    </p>
                ) : null}
            </div>
        );
    }

    render() {
        const { inputData,paymentMode } = this.state;

        const onSuccess = payment => {
            const inputData = { ...this.state.inputData };
            inputData['payment_id'] = payment.paymentID;
            this.setState({inputData});

            this.paymentApiCall();
        };

        const onCancel = data => {
            // User closed PayPal popup — no-op
        };

        const onError = err => {
            ToastDemo(
                this.props.toastManager,
                err && err.message ? err.message : "PayPal error",
                "error"
            );
            this.setState({
                loadingContentCard: null,
                buttonDisable: false,
            });
        };

        let env = configuration.get("configData.PAYPAL_MODE"); // you can set here to 'production' for production
        let currency = "USD"; // or you can set this value from your props or state
        let total = inputData.amount; // same as above, this is the total amount (based on currency) to be paid by using Paypal express checkout

        const client = {
            sandbox: configuration.get("configData.PAYPAL_ID"),
            production: configuration.get("configData.PAYPAL_ID")
        };
        const paypalVisible = isPaypalCheckoutVisible(
            configuration.get("configData")
        );

        const donationPage = this.state.donationPage || getDonationPageConfig();
        const amounts = donationPage.amounts && donationPage.amounts.length
            ? donationPage.amounts
            : ["10", "20", "50", "80", "100"];
        const currencySymbol = donationPage.currency_symbol || "$";
        const imageSrc =
            donationPage.image ||
            window.location.origin + "/assets/img/charity-img.jpg";
        const customLinks = Array.isArray(donationPage.custom_links)
            ? donationPage.custom_links
            : [];
        const branded = !!this.state.branded;
        const entityName =
            this.state.entityName || donationPage.title || t("donate_now");
        const entityNoun =
            this.state.entityType === "creator"
                ? "Creator"
                : this.state.entityType === "project"
                ? "Project"
                : "Organization";

        if (this.state.thankYouRedirect) {
            return <Redirect to={this.state.thankYouRedirect} />;
        }

        if (this.state.donationComplete && branded) {
            return (
                <div className="donate-feature-sec donate-feature-sec--branded main padding-top-md">
                    <div className="top-bottom-spacing resp-align-center">
                        <Container>
                            <div className="donate-thanks-card">
                                {this.renderSharedEntityIdentity({
                                    supportLine: false,
                                    poweredBy: false,
                                    entityName,
                                    entityNoun,
                                })}
                                <h2 className="donate-thanks-title">
                                    Thank you for supporting {entityName}
                                </h2>
                                {this.state.completedAmount != null ? (
                                    <p className="donate-thanks-amount">
                                        Donation confirmation · {currencySymbol}
                                        {this.state.completedAmount}
                                    </p>
                                ) : (
                                    <p className="donate-thanks-amount">
                                        Your donation has been received.
                                    </p>
                                )}
                                <p className="donate-checkout-identity__powered">
                                    Securely processed by Pentecost+
                                </p>
                                <AppearanceButton
                                    to={this.state.entityBackPath}
                                    variant="primary"
                                    className="donate-thanks-return"
                                >
                                    Return to {entityNoun}
                                </AppearanceButton>
                            </div>
                        </Container>
                    </div>
                </div>
            );
        }
        
        return (
            <>
                <div
                    className={
                        "donate-feature-sec main padding-top-md" +
                        (branded ? " donate-feature-sec--branded" : "")
                    }
                >
                    <div className="top-bottom-spacing resp-align-center">
                        <Container>
                            <Row>
                                <Col md={11} lg={10} sm={12} xl={11} className="auto-margin">
                                    {branded ? (
                                        <div className="donate-title-sec donate-title-sec--entity">
                                            {this.renderSharedEntityIdentity({
                                                supportLine: `Supporting this ${entityNoun}`,
                                                poweredBy: true,
                                                entityName,
                                                entityNoun,
                                            })}
                                        </div>
                                    ) : (
                                        <div className="donate-title-sec">
                                            <h2 className="donate-title">{donationPage.title || t('donate_now')}</h2>
                                            {donationPage.subtitle ? (
                                                <p>{donationPage.subtitle}</p>
                                            ) : null}
                                            {this.state.projectSlug ? (
                                                <p className="donate-project-context">
                                                    Contributing in support of project{" "}
                                                    <Link to={"/projects/" + this.state.projectSlug}>
                                                        {this.state.projectSlug}
                                                    </Link>
                                                    .{" "}
                                                    <Link to={"/projects/" + this.state.projectSlug}>
                                                        Back to project
                                                    </Link>
                                                </p>
                                            ) : null}
                                        </div>
                                    )}
                                </Col>
                            </Row>
                            <div className="donate-box">
                                <Form>
                                    <Row>
                                        <Col md={6} lg={5} className="donate-branded-aside-col">
                                            {branded ? (
                                                <div className="donate-branded-aside">
                                                    {this.state.entityCover ? (
                                                        <div
                                                            className="donate-branded-aside__cover"
                                                            style={{
                                                                backgroundImage:
                                                                    "url(" +
                                                                    resolveMediaUrl(
                                                                        this.state.entityCover
                                                                    ) +
                                                                    ")",
                                                            }}
                                                            role="img"
                                                            aria-label={
                                                                entityName +
                                                                " cover"
                                                            }
                                                        />
                                                    ) : (
                                                        <div
                                                            className="donate-branded-aside__cover donate-branded-aside__cover--empty"
                                                            aria-hidden="true"
                                                        />
                                                    )}
                                                    <div className="donate-branded-aside__message">
                                                        <p className="donate-branded-aside__support">
                                                            Your gift supports this{" "}
                                                            {entityNoun.toLowerCase()}{" "}
                                                            directly.
                                                        </p>
                                                    </div>
                                                    <p className="donate-branded-aside__note">
                                                        Pentecost+ securely
                                                        processes this donation.
                                                    </p>
                                                    <Link
                                                        to={this.state.entityBackPath}
                                                        className="donate-branded-aside__back"
                                                    >
                                                        Back to {entityNoun}
                                                    </Link>
                                                </div>
                                            ) : (
                                                <>
                                                    <Image
                                                        className="donate-left-img"
                                                        src={imageSrc}
                                                        alt={donationPage.title || t('donate_now')}
                                                    />
                                                    {donationPage.body
                                                        ? donationPage.body
                                                              .split(/\n+/)
                                                              .map((paragraph, index) => (
                                                                  <p key={`donate-body-${index}`}>
                                                                      {paragraph}
                                                                  </p>
                                                              ))
                                                        : null}
                                                </>
                                            )}
                                        </Col>
                                        <Col md={6} lg={7} className="donate-checkout-form-col">
                                            <Form>
                                                <h4>
                                                    {branded
                                                        ? "Donation Amount"
                                                        : donationPage.title || t("donate_now")}
                                                </h4>
                                                
                                                <div className="donate-amount-sec">
                                                    <div className="donate-amount-link">
                                                        <div className="mb-3">
                                                            {amounts.map((amount, index) => (
                                                                <Form.Check
                                                                    key={`donate-amount-${amount}`}
                                                                    custom
                                                                    inline
                                                                    label={String(amount)}
                                                                    type="radio"
                                                                    id={`donate-amount-${amount}`}
                                                                    value={amount}
                                                                    name="amount"
                                                                    defaultChecked={index === 0}
                                                                    onChange={this.handleChange}
                                                                />
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="or-divider">
                                                    <h6>Or</h6>
                                                </div>
                                                <div className="donate-amount-text-field">
                                                    <InputGroup className="mb-4">
                                                        <InputGroup.Prepend>
                                                            <InputGroup.Text id="basic-addon1">
                                                                {currencySymbol}
                                                            </InputGroup.Text>
                                                        </InputGroup.Prepend>
                                                        <FormControl
                                                            placeholder="Amount"
                                                            aria-label="Amount"
                                                            aria-describedby="basic-addon1"
                                                            name="amount"
                                                            value={inputData.amount ? inputData.amount : null}
                                                            onChange={this.handleChange}
                                                        />
                                                    </InputGroup>
                                                </div>
                                                <div className="donate-feature-form">
                                                    <Form.Group controlId="formBasicEmail">
                                                        <Form.Control 
                                                            type="text" 
                                                            placeholder={t('name')}
                                                            type="text"
                                                            name="name"
                                                            value={inputData.name ? inputData.name : null}
                                                            onChange={this.handleChange}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group controlId="formBasicEmail">
                                                        {/* <Form.Control 
                                                        type="text" 
                                                        placeholder="Last Name" 
                                                        name="last_name"
                                                        value={inputData.last_name ? inputData.last_name : null}
                                                        onChange={this.handleChange}
                                                        /> */}
                                                    </Form.Group>
                                                    <Form.Group controlId="formBasicEmail">
                                                        <Form.Control 
                                                            type="email" 
                                                            placeholder={t('email_address')}
                                                            name="email"
                                                            value={inputData.email ? inputData.email : null}
                                                            onChange={this.handleChange}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group controlId="formBasicEmail">
                                                        <Form.Control 
                                                            type="number" 
                                                            placeholder={t('mobile_number')}
                                                            name="mobile"
                                                            value={inputData.mobile ? inputData.mobile : null}
                                                            onChange={this.handleChange}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group controlId="exampleForm.ControlTextarea1">
                                                        <Form.Control as="textarea" rows={3}  placeholder={t('message')}
                                                        name="message"
                                                        value={inputData.message ? inputData.message : null}
                                                        onChange={this.handleChange}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group controlId="exampleForm.ControlTextarea1">
                                                        <Form.Control as="textarea" rows={3}  placeholder={t('description')}
                                                        name="description"
                                                        value={inputData.description ? inputData.description : null}
                                                        onChange={this.handleChange}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="donate-choose-payment-mode">
                                                    <h5>Choose Payment</h5>

                                                    <div className="donate-radio-btn">
                                                        {["radio"].map((type) => (
                                                            <div key={`custom-inline-${type}`} className="mb-3">
                                                                <Form.Check
                                                                    custom
                                                                    inline
                                                                    label={t('card')}
                                                                    type={type}
                                                                    id="card"
                                                                    value="card"
                                                                    defaultChecked={true}
                                                                    name="payment_method"
                                                                    onChange={
                                                                        this.handleChangePayment
                                                                    }
                                                                />
                                                                {paypalVisible &&
                                                                configuration.get(
                                                                    "configData.PAYPAL_ID"
                                                                ) ? (
                                                                    <Form.Check
                                                                        custom
                                                                        inline
                                                                        label={t('paypal')}
                                                                        type={type}
                                                                        // id={`custom-inline-${type}-2`}
                                                                        id="paypal"
                                                                        value="paypal"
                                                                        name="payment_method"
                                                                        onChange={
                                                                            this.handleChangePayment
                                                                        }
                                                                    />
                                                                ) : (
                                                                    ""
                                                                )}
                                                                {configuration.get("configData.is_razorpay_enabled") == 1 ? (

                                                                    <Form.Check
                                                                        custom
                                                                        inline
                                                                        label={t('razorpay')}
                                                                        type={type}
                                                                        id="razorpay"
                                                                        value="razorpay"
                                                                        name="payment_method"
                                                                        onChange={
                                                                            this.handleChangePayment
                                                                        }
                                                                    />

                                                                ) : (
                                                                    ""
                                                                )}
                                                                {configuration.get("configData.is_paystack_enabled") == 1 ? (

                                                                    <Form.Check
                                                                        custom
                                                                        inline
                                                                        label={t('paystack')}
                                                                        type={type}
                                                                        id="paystack"
                                                                        value="paystack"
                                                                        name="payment_method"
                                                                        onChange={
                                                                            this.handleChangePayment
                                                                        }
                                                                    />

                                                                ) : (
                                                                    ""
                                                                )}
                                                                <Link
                                                                    to="/add-card"
                                                                    className="float-right btn-link"
                                                                >
                                                                    {t("add_card")}
                                                                </Link>
                                                            </div>
                                                        ))}
                                                    </div>

                                                    <div className="donate-choose-payment-btn-sec">
                                                        
                                                        {paymentMode == "paypal" && paypalVisible ? 
                                                            <PaypalExpressBtn
                                                                env={env}
                                                                client={client}
                                                                currency={currency}
                                                                total={total}
                                                                onError={onError}
                                                                onSuccess={
                                                                    onSuccess
                                                                }
                                                                onCancel={onCancel}
                                                            />
                                                        : 
                                                            <AppearanceButton
                                                                type="button"
                                                                variant="primary"
                                                                onClick={
                                                                    this
                                                                        .handleSubmit
                                                                }
                                                                disabled={
                                                                    this.state
                                                                        .buttonDisable
                                                                }
                                                            >
                                                                {donationPage.cta_label || t("pay_now")}
                                                            </AppearanceButton>
                                                        }
                                                    
                                                    </div>
                                                </div>
                                            </Form>
                                            <div className="donate-amount-sec">
                                                <div className="donate-footer-desc-sec">
                                                    {branded ? (
                                                        <p className="donate-processed-by">
                                                            Securely processed by Pentecost+
                                                        </p>
                                                    ) : null}
                                                    <p>
                                                        {donationPage.legal_text}
                                                        {donationPage.privacy_link_url ? (
                                                            <>
                                                                {" "}
                                                                {isExternalHref(donationPage.privacy_link_url) ? (
                                                                    <a
                                                                        href={normalizeExternalUrl(
                                                                            donationPage.privacy_link_url
                                                                        )}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        {donationPage.privacy_link_label || "Privacy Policy"}
                                                                    </a>
                                                                ) : (
                                                                    <Link to={donationPage.privacy_link_url}>
                                                                        {donationPage.privacy_link_label || "Privacy Policy"}
                                                                    </Link>
                                                                )}
                                                            </>
                                                        ) : null}
                                                    </p>
                                                    {customLinks.length ? (
                                                        <p>
                                                            {customLinks.map((link, index) => (
                                                                <span key={`donate-custom-link-${index}`}>
                                                                    {index > 0 ? " · " : ""}
                                                                    {isExternalHref(link.url) ? (
                                                                        <a
                                                                            href={normalizeExternalUrl(link.url)}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                        >
                                                                            {link.label}
                                                                        </a>
                                                                    ) : (
                                                                        <Link to={link.url}>{link.label}</Link>
                                                                    )}
                                                                </span>
                                                            ))}
                                                        </p>
                                                    ) : null}
                                                    <div className="mt-3">
                                                        <BrandLinksRow placement="donation_page" />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </Container>
                    </div>
                </div>
            </>
        );
    }
};

export default withToastManager(translate(DonateFeature));
